import React from 'react'
import './hero.css';
import PlayCircleRoundedIcon from '@mui/icons-material/PlayCircleRounded';
import building2 from '../imgs/building2.jpg';
import building3 from '../imgs/building3.jpg';
import building4 from '../imgs/building4.jpg';
import building1 from '../imgs/building1.jpg';
import building5 from '../imgs/building5.jpg';
import { useNavigate } from 'react-router-dom';
import Nav from '../Nav/Nav'

const Hero = () => {
    const navigate=useNavigate();
    function GoToFilter(){
        navigate('/filter');
    }

  return (
    <div>
        <Nav/>

        <div className="Hero">
            <div className="HeroLeft">
                <div className="HeroLeftTitle">Let Us Help You <br/> To Choose <br/> The Best.</div>
                <div className="HeroLeftSubTitle">
                    In expecting It is a long established fact that a reader will be distracted by the readable content of a page. 
                    Many desktop publishing packages and web page editors now use Lorem Ipsum as their default model text.
                </div>
                <div className="HeroLeftButtons">
                    <button className="HeroLeftButtons1" onClick={GoToFilter}>Learn More</button>
                    <button className="HeroLeftButtons2" onClick={GoToFilter}><PlayCircleRoundedIcon/> Watch Video</button>
                </div>
            </div>
            <div className="HeroRight">
                <div className='HeroRightImg12'>
                <div className="HeroRightImg1"><img src={building1} alt="" className="HeroRightImg1" /></div>
                <div className="HeroRightImg2"><img src={building2} alt="" className="HeroRightImg2" /></div>
                </div>
                <div className="HeroRightImg3"><img src={building3} alt="" className="HeroRightImg3" /></div>
                <div className="HeroRightImg4"><img src={building4} alt="" className="HeroRightImg4" /></div>
            </div>
            <div className="HeroBottom">
                    <div className="HeroBottomDropDowns">
                       <span className="HeroBottomDropDowns1">
                        <label htmlFor="Location" className="Location">Locations</label><i className=''></i>
                        <select name="Location" id="Location">
                            <option value="ba">Bangladesh</option>
                            <option value="in">India</option>
                            <option value="ir">Iran</option>
                            <option value="we">West</option>
                        </select>
                       </span>
                       <span className="HeroBottomDropDowns2">
                        <label htmlFor="Location" className="Property">Property Type</label>
                        <select name="Location" id="Location">
                            <option value="volvo">Flat</option>
                            <option value="saab">Bungalow</option>
                            <option value="mercedes">Rent</option>
                            <option value="audi">Buy</option>
                        </select>
                       </span>

                       <span className="HeroBottomDropDowns3">
                        <label htmlFor="Location" className="Location">Max Price</label>
                        <select name="Location" id="Location">
                            <option value="volvo">4 Lakh</option>
                            <option value="saab">20 Lakh</option>
                            <option value="mercedes">40 Lakh</option>
                            <option value="audi">80 Lakh</option>
                        </select>
                      </span>

                      <span >
                        <button className="HeroBottomButton" onClick={GoToFilter}>Search</button>
                      </span>
                    </div>
            </div>
        </div>

        <div></div>
    </div>

  )
}

export default Hero